import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FurlissimoHome from './pages/FurlissimoHome';
import About from './pages/About.jsx';
import DogGrooming from './pages/DogGrooming.jsx';
import Galeri from './pages/Galeri.jsx';
import VisitAsContact from './pages/VisitAsContact.jsx';
import ClientFeedback from './pages/clientfeedback.jsx';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-gray-50 text-gray-800">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<FurlissimoHome />} />
            <Route path="/about" element={<About />} />
            <Route path="/grooming" element={<DogGrooming />} />
            <Route path="/galeri" element={<Galeri />} />
            <Route path="/contact" element={<VisitAsContact />} />
            <Route path="/feedback" element={<ClientFeedback />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;